"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PPIconLink = void 0;
var react_1 = __importDefault(require("react"));
require("../../assets/PPIconLink.css");
var PPIconLink = function (props) {
    return (react_1.default.createElement("div", { id: props.id, className: "pp-iconlink".concat(props.disabled ? ' disabled' : '', " ").concat(props.size || ''), onClick: function () { return !props.disabled && props.onClick && props.onClick(); } },
        react_1.default.createElement("i", { className: props.icon, style: { color: props.color } }),
        props.badge && props.badge.number > 0 &&
            react_1.default.createElement("div", { className: "badge bg-".concat(props.badge.status) },
                react_1.default.createElement("span", null, props.badge.number > 99 ? '+99' : props.badge.number)),
        props.tooltip &&
            react_1.default.createElement("div", { className: "tooltip ".concat(props.tooltipPosition || '') },
                react_1.default.createElement("div", { className: "body ".concat(props.tooltipPosition || '') },
                    react_1.default.createElement("span", { className: "arrow ".concat(props.tooltipPosition || '') }),
                    react_1.default.createElement("div", { className: "content ".concat(props.tooltipPosition || '') }, props.tooltip)))));
};
exports.PPIconLink = PPIconLink;
